import CustomHtml from "../CustomHtml/component";
import classNames from "classnames";
import { getTrackingPixel } from "../../utils/tracking/library";

type BusinessWidgetProps = {
    height?: string;
    src?: string;
    trackingSrc?: string;
    name?: string;
};

/**
 * The Businesswidget component.
 *
 * @param {Object} props The component properties
 * @returns {React.Component} The BusinessWidget component
 */
export function BusinessWidget(props: BusinessWidgetProps) {
    const businessWidgetClasses = classNames("businessWidget", [props.name]);

    const title = getTitleString(props.name);
    const titleMarkup = title ? (
        <h4 className="businessWidgetTitle">{title}</h4>
    ) : null;

    return (
        <div className={businessWidgetClasses} data-testid="business-widget">
            {titleMarkup}
            <CustomHtml
                src={props.src}
                height={props.height}
                name={"Market Snapshot"}
            />
            {getTrackingPixel(props.trackingSrc)}
        </div>
    );
}

/**
 * Set a title string based on the widget name
 *
 * @param {String} widgetName The widget name
 * @returns {String} A title string or null
 */
function getTitleString(widgetName?: string) {
    let titleString = null;

    if (widgetName === "forexMarketOverview") {
        titleString = "Currencies";
    } else if (widgetName === "symbolSearch") {
        titleString = "Quotes";
    }

    return titleString;
}

export default BusinessWidget;
